import { useEffect, useState } from "react"
import { api } from "../services/api"

export const useCustomers = () => {
  const [customers, setCustomers] = useState([])
  const [enterprise, setEnterprise] = useState([])

  async function getAllEnterpriseActive() {
    try {
      const response = await api.get('https://api.innovationbrindes.com.br/api/site/v2/pedido/lista-empresas')

      setEnterprise(response.data)

      return response.data
    } catch (error) {
      console.log(error)
      return []
    }
  }

  async function getAllCustomersActive() {
    try {
      const response = await api.get('/site/v2/editar-pedido/listar-vendedores')
      setCustomers(response.data)

    } catch (error) {
      console.log(error)
      return []
    }
  }

  useEffect(() => {
    getAllCustomersActive()
    getAllEnterpriseActive()
  }, [])

  return { customers, enterprise }
}